// extracted by mini-css-extract-plugin
export default {"filters":"LiveBettingSports_filters__33RNC","head2headContainer":"LiveBettingSports_head2headContainer__agU+b","card":"LiveBettingSports_card__Sjl1Y"};